import { Alert } from 'bold-ui'

export function AlertEdicaoNaoAlteraCadastro() {
  return (
    <Alert inline type='warning' style={styles.alert}>
      Edições feitas neste formulário não alteram os dados do cadastro do cidadão.
    </Alert>
  )
}

const styles = {
  alert: {
    width: '100%',
  },
}
